import React from 'react';
import Address from '../../address/address.jsx';

const FAddress = () => (
  <Address
    prefix="f"
    placeholder="Фактический адрес"
    isCollapsible
  />
);

export default FAddress;
